<div class="modal-overlay">
  <div class="modal-content">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeModal()">
      &times;
    </button>

    <div class="modal-body">
      <div class="modal-header">
        <h2>{{ mode === 'edit' ? ('assignPackage.modalEditTitle' | t:'Edit Assign Package') : ('assignPackage.modalNewTitle' | t:'New Assign Package') }}</h2>
      </div>

      <div class="form-message info form-message-block" *ngIf="isLoadingOptions">Loading options...</div>

      <form [formGroup]="assignForm" (ngSubmit)="onSubmit()">
        <div class="form-layout">
          <div class="form-section">
            <div class="section-title">Assignment</div>
            <div class="form-row two-col">
              <div class="form-group">
                <app-common-dropdown
                  [dropdownObj]="userDropdownObj"
                  [value]="assignForm.get('userId')?.value"
                  (valueChange)="onUserChange($event)"
                  (optionsLoaded)="onUserOptionsLoaded($event)"
                ></app-common-dropdown>
                <div class="field-error" *ngIf="hasError('userId', 'required')">User is required.</div>
              </div>

              <div class="form-group">
                <app-common-dropdown
                  [dropdownObj]="packageDropdownObj"
                  [value]="packageSelectionId"
                  (valueChange)="onPackageSelectionChange($event)"
                  (optionsLoaded)="onPackageOptionsLoaded($event)"
                ></app-common-dropdown>
                <div class="field-error" *ngIf="hasError('packageName', 'required')">Package is required.</div>
              </div>
            </div>
          </div>

          <div class="form-section">
            <div class="section-title">Package Snapshot</div>
            <div class="form-row three-col">
              <div class="form-group">
                <label>{{ 'package.name' | t:'Package Name' }} *</label>
                <input type="text" formControlName="packageName" [readonly]="isReadonlyForPackageFields()" />
                <div class="field-error" *ngIf="hasError('packageName', 'required')">Package name is required.</div>
              </div>

              <div class="form-group">
                <label>{{ 'assignPackage.price' | t:'Price' }} *</label>
                <input type="number" min="0" step="0.01" formControlName="price" [attr.readonly]="isPriceReadonly() ? true : null" [class.readonly-input]="isPriceReadonly()" (focus)="clearZeroOnFocus('price')" />
                <div class="field-error" *ngIf="hasError('price', 'required') || hasError('price', 'min')">Enter a valid price.</div>
              </div>

              <div class="form-group">
                <label>{{ 'payment.remarks' | t:'Remarks' }}</label>
                <input type="text" maxlength="255" formControlName="remarks" [readonly]="isReadonlyForPackageFields()" />
              </div>
            </div>
            <div class="trial-toggle-wrap">
              <label class="trial-toggle">
                <input type="checkbox" formControlName="isTrial" (change)="onTrialToggle($event)" />
                <span>Trial</span>
              </label>
              <span class="trial-toggle-note">If selected, price will be 0.</span>
            </div>
          </div>

          <div class="form-section">
            <div class="section-title">Usage Limits</div>
            <div class="form-row four-col">
              <div class="form-group">
                <label>{{ 'package.totalFlat' | t:'Total Flat' }} *</label>
                <input type="number" min="0" formControlName="maxActiveFlat" [readonly]="isReadonlyForPackageFields()" (focus)="clearZeroOnFocus('maxActiveFlat')" />
                <div class="field-error" *ngIf="hasError('maxActiveFlat', 'required') || hasError('maxActiveFlat', 'min')">Enter a valid flat limit.</div>
              </div>

              <div class="form-group">
                <label>{{ 'package.totalRenter' | t:'Total Renter' }} *</label>
                <input type="number" min="0" formControlName="maxActiveRenter" [readonly]="isReadonlyForPackageFields()" (focus)="clearZeroOnFocus('maxActiveRenter')" />
                <div class="field-error" *ngIf="hasError('maxActiveRenter', 'required') || hasError('maxActiveRenter', 'min')">Enter a valid renter limit.</div>
              </div>

              <div class="form-group">
                <label>{{ 'package.maxActiveEmployee' | t:'Subuser' }} *</label>
                <input type="number" min="0" formControlName="maxActiveEmployee" [readonly]="isReadonlyForPackageFields()" (focus)="clearZeroOnFocus('maxActiveEmployee')" />
                <div class="field-error" *ngIf="hasError('maxActiveEmployee', 'required') || hasError('maxActiveEmployee', 'min')">Enter a valid subuser limit.</div>
              </div>

              <div class="form-group">
                <label>{{ 'package.maxFileMemory' | t:'Max File Memory (MB)' }} *</label>
                <input type="number" min="0" formControlName="maxFileStorage" [readonly]="isReadonlyForPackageFields()" (focus)="clearZeroOnFocus('maxFileStorage')" />
                <div class="field-error" *ngIf="hasError('maxFileStorage', 'required') || hasError('maxFileStorage', 'min')">Enter a valid file storage limit.</div>
              </div>
            </div>
          </div>

          <div class="form-section">
            <div class="section-title">Duration</div>
            <div class="form-row three-col align-end">
              <div class="form-group">
                <app-common-dropdown
                  [dropdownObj]="durationDropdownObj"
                  [value]="assignForm.get('durationUnite')?.value"
                  (valueChange)="onDurationChange($event)"
                ></app-common-dropdown>
                <div class="field-error" *ngIf="hasError('durationUnite', 'required')">Duration type is required.</div>
              </div>

              <div class="form-group">
                <label>{{ 'assignPackage.durationQuantity' | t:'Duration Quantity' }} *</label>
                <div class="floor-scale-wrap">
                  <button type="button" class="scale-btn" (click)="decreaseDurationQuantity()">-</button>
                  <input
                    type="range"
                    formControlName="durationQuantity"
                    [min]="durationScaleMin"
                    [max]="durationScaleMax"
                    step="1"
                    (input)="onDurationScaleInput($event)"
                  />
                  <button type="button" class="scale-btn" (click)="increaseDurationQuantity()">+</button>
                </div>
                <div class="floor-scale-value">{{ durationQuantityDisplay() }}</div>
                <div class="field-error" *ngIf="hasError('durationQuantity', 'required') || hasError('durationQuantity', 'min')">Enter a valid duration quantity.</div>
              </div>

              <div class="form-group">
                <label>{{ 'assignPackage.expireDate' | t:'Expire Date' }}</label>
                <div class="date-input-wrap">
                  <input
                    type="text"
                    class="date-input"
                    [value]="expireDateDisplay()"
                    [placeholder]="'placeholder.selectDate' | t:'Select date'"
                    readonly
                    (click)="picker.open()"
                  />
                  <button type="button" class="date-picker-btn" [attr.aria-label]="'placeholder.selectDate' | t:'Pick date'" (click)="picker.open()">
                    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1Zm13 8H4v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8ZM5 6a1 1 0 0 0-1 1v1h16V7a1 1 0 0 0-1-1H5Z"/>
                    </svg>
                  </button>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    [value]="matExpireDateValue"
                    class="mat-date-anchor"
                    (dateChange)="onExpireDateSelected($event)"
                    tabindex="-1"
                    aria-hidden="true"
                  />
                  <mat-datepicker #picker></mat-datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-message error form-message-block" *ngIf="error">{{ error }}</div>

        <div class="form-actions">
          <div class="total-price-chip">
            <span class="total-price-label">Total Price</span>
            <span class="total-price-value">{{ formatPrice(totalPrice()) }}</span>
          </div>
          <button type="button" class="secondary-btn" [disabled]="isSubmitting" (click)="closeModal()">
            {{ 'common.close' | t:'Close' }}
          </button>
          <button class="PositiveBTN" type="submit" [disabled]="isSubmitting || isLoadingOptions">
            {{ isSubmitting ? ('common.saving' | t:'Saving...') : (mode === 'edit' ? ('assignPackage.updateButton' | t:'Update Assign Package') : ('assignPackage.addButton' | t:'Add Assign Package')) }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
